export class MailTemplateDto {
    keyId: string = '';
    id: string = '';
    code: string = '';
    name: string = '';
    mailFrom: string = '';
    mailTo: string = '';
    mailCc: string = '';
    mailBcc: string = '';
    mailTitle: string = '';
    mailContent: string = '';
    remarks: string = '';
}